import { render, staticRenderFns } from "./Kalender.vue?vue&type=template&id=a2c10976"
import script from "./Kalender.vue?vue&type=script&lang=js"
export * from "./Kalender.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports